<div class="w-full" *ngIf="errorMessages">
    <h2 class="text-red-500 pt-8 text-2xl font-semibold text-center">Wystąpił błąd<i class="pi pi-exclamation-triangle px-2 text-2xl"></i></h2>
    <div class="mx-auto w-full text-red-600">
      <ul [ngClass]="{'list-disc': errorMessages.length > 1}">
        <li *ngFor="let errorMessage of errorMessages; trackBy: trackByIndex" class="text-center">{{ errorMessage }}</li>
      </ul>
    </div>
  </div>